/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventClassification } from './EventClassification';
import {
    EventClassificationFromJSON,
    EventClassificationFromJSONTyped,
    EventClassificationToJSON,
    EventClassificationToJSONTyped,
} from './EventClassification';
import type { EventPriceRange } from './EventPriceRange';
import {
    EventPriceRangeFromJSON,
    EventPriceRangeFromJSONTyped,
    EventPriceRangeToJSON,
    EventPriceRangeToJSONTyped,
} from './EventPriceRange';
import type { EventVenue } from './EventVenue';
import {
    EventVenueFromJSON,
    EventVenueFromJSONTyped,
    EventVenueToJSON,
    EventVenueToJSONTyped,
} from './EventVenue';

/**
 * Provider-neutral event discovery metadata.
 * @export
 * @interface EventSummary
 */
export interface EventSummary {
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    url: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventSummary
     */
    attractionNames?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof EventSummary
     */
    localDate?: Date;
    /**
     * 1-based position of this event when the result set is ordered by cheapest listing, counted against price_ranked_total. Set by the server from the provider's own ordering; never inferred from array position, which carries no such guarantee.
     * @type {number}
     * @memberof EventSummary
     */
    priceRank?: number;
    /**
     * Local wall-clock time supplied by the event provider.
     * @type {string}
     * @memberof EventSummary
     */
    localTime?: string;
    /**
     * 
     * @type {Date}
     * @memberof EventSummary
     */
    datetimeUtc?: Date;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    status?: string;
    /**
     * 
     * @type {EventVenue}
     * @memberof EventSummary
     */
    venue?: EventVenue;
    /**
     * 
     * @type {EventClassification}
     * @memberof EventSummary
     */
    classification?: EventClassification;
    /**
     * 
     * @type {EventPriceRange}
     * @memberof EventSummary
     */
    priceRange?: EventPriceRange;
    /**
     * 
     * @type {Date}
     * @memberof EventSummary
     */
    publicSaleStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventSummary
     */
    publicSaleEnd?: Date;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the EventSummary interface.
 */
export function instanceOfEventSummary(value: object): value is EventSummary {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function EventSummaryFromJSON(json: any): EventSummary {
    return EventSummaryFromJSONTyped(json, false);
}

export function EventSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['event_id'],
        'source': json['source'],
        'name': json['name'],
        'url': json['url'],
        'attractionNames': json['attraction_names'] == null ? undefined : json['attraction_names'],
        'localDate': json['local_date'] == null ? undefined : (new Date(json['local_date'])),
        'priceRank': json['price_rank'] == null ? undefined : json['price_rank'],
        'localTime': json['local_time'] == null ? undefined : json['local_time'],
        'datetimeUtc': json['datetime_utc'] == null ? undefined : (new Date(json['datetime_utc'])),
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'status': json['status'] == null ? undefined : json['status'],
        'venue': json['venue'] == null ? undefined : EventVenueFromJSON(json['venue']),
        'classification': json['classification'] == null ? undefined : EventClassificationFromJSON(json['classification']),
        'priceRange': json['price_range'] == null ? undefined : EventPriceRangeFromJSON(json['price_range']),
        'publicSaleStart': json['public_sale_start'] == null ? undefined : (new Date(json['public_sale_start'])),
        'publicSaleEnd': json['public_sale_end'] == null ? undefined : (new Date(json['public_sale_end'])),
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
    };
}

export function EventSummaryToJSON(json: any): EventSummary {
    return EventSummaryToJSONTyped(json, false);
}

export function EventSummaryToJSONTyped(value?: EventSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_id': value['eventId'],
        'source': value['source'],
        'name': value['name'],
        'url': value['url'],
        'attraction_names': value['attractionNames'],
        'local_date': value['localDate'] == null ? value['localDate'] : value['localDate'].toISOString().substring(0,10),
        'price_rank': value['priceRank'],
        'local_time': value['localTime'],
        'datetime_utc': value['datetimeUtc'] == null ? value['datetimeUtc'] : value['datetimeUtc'].toISOString(),
        'timezone': value['timezone'],
        'status': value['status'],
        'venue': EventVenueToJSON(value['venue']),
        'classification': EventClassificationToJSON(value['classification']),
        'price_range': EventPriceRangeToJSON(value['priceRange']),
        'public_sale_start': value['publicSaleStart'] == null ? value['publicSaleStart'] : value['publicSaleStart'].toISOString(),
        'public_sale_end': value['publicSaleEnd'] == null ? value['publicSaleEnd'] : value['publicSaleEnd'].toISOString(),
        'image_url': value['imageUrl'],
    };
}

